import { AccordionModule } from 'primeng/accordion';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from "primeng/toast";
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
// FormsModule ademas de ReactiveFormsModule: los formularios del proyecto son
// reactivos, pero algunas listas de arity variable —los botones de una plantilla
// de WhatsApp— se editan con [(ngModel)] y [ngModelOptions]="{standalone: true}",
// que necesita este modulo.
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { SkeletonModule } from 'primeng/skeleton';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { CheckboxModule } from 'primeng/checkbox';
import { TriStateCheckboxModule } from "primeng/tristatecheckbox";
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { FileUploadModule } from 'primeng/fileupload';
import { ProgressBarModule } from 'primeng/progressbar';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ChipsModule } from 'primeng/chips';
import { DropdownModule } from 'primeng/dropdown';
import { AvatarModule } from 'primeng/avatar';
import { SplitButtonModule } from 'primeng/splitbutton';
import { BadgeModule } from "primeng/badge";
import { ImageModule } from "primeng/image";
import { FieldsetModule } from "primeng/fieldset";
import { InputMaskModule } from "primeng/inputmask";
import { RadioButtonModule } from "primeng/radiobutton";
import { TagModule } from "primeng/tag";
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CardModule } from 'primeng/card';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { SidebarModule } from 'primeng/sidebar';
import { DividerModule } from 'primeng/divider';
import { TimelineModule } from 'primeng/timeline';

export const PI_MODULES = [
    CardModule,
    InputSwitchModule,
    InputTextareaModule,
    SidebarModule,
    DividerModule,
    TimelineModule,
    ToastModule,
    ToolbarModule,
    ButtonModule,
    TableModule,
    InputTextModule,
    ReactiveFormsModule,
    SkeletonModule,
    DialogModule,
    InputNumberModule,
    CheckboxModule,
    TriStateCheckboxModule,
    MultiSelectModule,
    CalendarModule,
    FileUploadModule,
    ProgressBarModule,
    TabViewModule,
    TooltipModule,
    ConfirmDialogModule,
    ProgressSpinnerModule,
    ChipsModule,
    DropdownModule,
    AvatarModule,
    SplitButtonModule,
    BadgeModule,
    ImageModule,
    FieldsetModule,
    InputMaskModule,
    RadioButtonModule,
    TagModule,
    AutoCompleteModule,
    AccordionModule,
    MessageModule,
    MessagesModule,
    FormsModule
]
